import { render, staticRenderFns } from "./Couriers.vue?vue&type=template&id=fbc71b64&scoped=true"
import script from "./Couriers.vue?vue&type=script&lang=js"
export * from "./Couriers.vue?vue&type=script&lang=js"
import style0 from "./Couriers.vue?vue&type=style&index=0&id=fbc71b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc71b64",
  null
  
)

export default component.exports